'use client';

import { BulkOperationProps } from '@type/bulk-operations';
import {
  BulkMessage,
  BulkSendCv,
  BulkCopyApplicants,
  BulkValidate,
} from '@components/templates/employer/applicant-list/bulk-operations';

interface BulkActionsPanelProps extends BulkOperationProps {
  barWidth?: number;
}

/**
 * @description Renders the individual bulk action components (message, send CV, copy, validate)
 * as a chip-area panel to be shown in the `above` slot of CompanyApplicantFloatingNavBar.
 *
 * Each action retains its own trigger button + modal logic. The panel provides the shared
 * visual container (same style as the career-coaching chip area in CandidateFloatingNavBar).
 */
export const BulkActionsPanel = ({ ...bulkProps }: BulkActionsPanelProps) => (
  <div className="inline-flex flex-col gap-1 rounded-2xl bg-surface p-3 shadow-lg [&_button:hover]:no-underline [&_button]:py-3">
    <BulkMessage {...bulkProps} />
    <BulkSendCv {...bulkProps} />
    <BulkCopyApplicants {...bulkProps} />
    <BulkValidate {...bulkProps} />
  </div>
);
